import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPriceListServicesAvailableColumns } from './api';

export const path = '/calculator-tariff/price-list-services/list';

const PagePriceListServices: React.FC = (props) => {
  const PriceListServices = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPriceListServicesAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PriceListServices {...props} />;
};

export default PagePriceListServices;
